import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { speedCoachingProfileSchema } from '../schemas/speed-coaching-profile.schema';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Returns a paginated response for Speed Coaching Profiles
 * @param params Paged Collection Params
 * @returns Paged Collection of Speed Coaching Profiles
 */
export function getSpeedCoaching(
  this: unknown,
  params?: PagedCollectionParams
) {
  const requestUrl = `${fleetEnvironment.resolve(this).speedCoachingUrl}?${
    params ? params.urlParams : ''
  }`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(createPagedCollectionSchema(speedCoachingProfileSchema)));
}
